import { render } from "./MapConfig.vue?vue&type=template&id=35cd7c62&scoped=true"
import script from "./MapConfig.vue?vue&type=script&lang=js"
export * from "./MapConfig.vue?vue&type=script&lang=js"

import "./MapConfig.vue?vue&type=style&index=0&id=35cd7c62&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35cd7c62"]])

export default __exports__